export default __webpack_public_path__ + "static/media/img-0586-poland-full-face.2c8ace4b.png";